import Vue from 'vue';
import Vuex from 'vuex';
import {AxiosResponse} from 'axios';
import {SshKey, RootState} from '@/interfaces/interfaces';
import http from '@/http/http';
import httpHandleError from '@/http/httpHandleError';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    availableKeyPairs: [],
    sshKey: null,
    isLoading: true,
  } as RootState,
  mutations: {
    setAvailableKeyPairs(state, payload) {
      state.availableKeyPairs = payload;
    },
    TOGGLE_LOADING(state: RootState, {isLoading}: { isLoading: boolean }): void {
      Vue.set(state, 'isLoading', isLoading);
    },
  },
  actions: {
    async fetchAvailableKeyPairs() {
      this.commit('TOGGLE_LOADING', {isLoading: true});
      http().get('/get')
        .then((response: AxiosResponse) => {
          this.commit('setAvailableKeyPairs', response.data);
          this.commit('TOGGLE_LOADING', {isLoading: false});
        })
        .catch(httpHandleError);
    },
    addKey({commit, dispatch}: any, sshKeyValue) {
      if (!this.state.availableKeyPairs.some((k) => k.value === sshKeyValue)) {
        this.commit('TOGGLE_LOADING', {isLoading: true});
        http().post('/post', {value: sshKeyValue})
          .then((response: AxiosResponse) => {
            dispatch('fetchAvailableKeyPairs');
          })
          .catch(httpHandleError);
      }
    },
    removeKey({commit, dispatch}: any, sshKey: SshKey) {
      if (this.state.availableKeyPairs.some((k) => k.value === sshKey.value)) {
        this.commit('TOGGLE_LOADING', {isLoading: true});
        http().delete(`/delete/${sshKey.id}`)
          .then((response: AxiosResponse) => {
            dispatch('fetchAvailableKeyPairs');
          })
          .catch(httpHandleError);
      }
    },
    setKey({commit}, sshKey: SshKey) {
      this.commit('setAvailableKeyPairs', sshKey);
    },
  },
  getters: {
    availableKeyPairs(state): SshKey[] {
      return state.availableKeyPairs;
    },
  },
});
